import { createRouter, createWebHashHistory } from 'vue-router';
import Login from './components/Login.vue';
import Calendar from './components/Calendar.vue';
import MasterData from './components/MasterData.vue';
import TimeViewer from './components/TimeViewer.vue';
import Admin from './components/Admin.vue';

const routes = [
  { path: '/', name: 'index', component: Login },
  { path: '/calendar', name: 'calendar',  component: Calendar },
  { path: '/masterdata', name: 'masterdata',  component: MasterData },
  { path: '/timeviewer', name: 'timeviewer',  component: TimeViewer },
  { path: '/admin', name: 'admin',  component: Admin },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;